import { Anchor, Flex } from 'antd';
import './TableOfContent.css';
import React from 'react';

export const extractTOC = (json) => {
  const headings = [];
  let index = 0;

  const traverse = (node) => {
    if (node.type === 'heading' && node.attrs.level >= 1 && node.attrs.level < 4) {
      const text = node.content
        ?.map((child) => {
          if (child.type === 'text') return child.text;
          return '';
        })
        .join(' ');
      let id = node.attrs.id || null;
      if (id === null) {
        id =
          String(text)
            .replace(/[^\w\s]/g, '')
            .trim()
            .replace(/^_+|_+$/g, '')
            .replace(/\s+/g, '_') + index.toString();
        index = index + 1;
      }
      headings.push({ text, level: node.attrs.level, id, children: [] });
    }
    if (node.content) node.content.forEach(traverse);
  };

  traverse(json);
  return headings;
};

export const buildTOCTree = (headings) => {
  const root = [];
  const stack = [];

  headings.forEach((heading) => {
    while (stack.length > 0 && stack[stack.length - 1].level >= heading.level) {
      stack.pop();
    }

    if (stack.length === 0) {
      root.push(heading);
    } else {
      stack[stack.length - 1].children.push(heading);
    }

    stack.push(heading);
  });

  return root;
};

export const transformToAnchorItems = (nodes) => {
  return nodes.map((node, index) => ({
    key: index.toString(),
    href: `#${node.id}`,
    title: node.text,
    children: node.children.length > 0 ? transformToAnchorItems(node.children) : undefined,
  }));
};

export const TableOfContent = ({ content, container }) => {
  return (
    <Flex vertical className="toc__root">
      <Flex className="toc_container">
        {content?.length > 0 && (
          <Anchor
            getContainer={() => container}
            offsetTop={100}
            style={{
              maxWidth: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxHeight: 'unset',
            }}
            affix={false}
            items={content}
          />
        )}
      </Flex>
    </Flex>
  );
};

export default TableOfContent;
